export default __webpack_public_path__ + "static/media/success-green.3b82cbed.gif";